import { KnowledgeItem } from '../../types/learning';
import { supermemo, SuperMemoItem, SuperMemoGrade } from 'supermemo';
import { addDays } from 'date-fns';

/**
 * Updates a KnowledgeItem using the SM-2 spaced repetition algorithm.
 * @param item The knowledge item to update.
 * @param grade The performance grade (0-5).
 * @returns The updated KnowledgeItem.
 */
export function updateKnowledgeItemReview(
  item: KnowledgeItem,
  grade: SuperMemoGrade
): KnowledgeItem {
  // Prepare the subset for supermemo
  const smItem: SuperMemoItem = {
    interval: item.interval,
    repetition: item.repetition,
    efactor: item.efactor,
  };

  // Run the SM-2 algorithm
  const result = supermemo(smItem, grade);

  // Calculate next review date
  const now = new Date();
  const nextReviewDate = addDays(now, result.interval);

  // Return updated item
  return {
    ...item,
    interval: result.interval,
    repetition: result.repetition,
    efactor: result.efactor,
    lastReviewed: now,
    nextReviewDate,
    performanceHistory: [...item.performanceHistory, grade],
  };
}

/**
 * Type alias for the SuperMemo performance grade (0-5) used in spaced repetition.
 * Re-exported for use in challenge and utility components.
 */
export type { SuperMemoGrade }; 